import "./App.css";

import Simple from "./components/Navbar/Navbar";

function App() {
  return (
    <>
      <Simple />
    </>
  );
}

export default App;
